<template>
    <span class="run-dates text-truncate" :class="classes">
        {{ runDates }}
    </span>
</template>

<script>
export default {
    props: {
        start: {},
        end: {},
        separator: {
            type: String,
            default: '-',
        },
        dates: {
            type: Array,
        },
        format: {
            default: 'date',
        },
        // Additional classes to apply to the span element
        classes: {
            type: [String, Array, Object],
            default: '',
        },
    },
    computed: {
        runDates() {
            const _this = this;

            if (this.dates) {
                return _.map(this.dates, (date) => {
                    return dateTimeString(date, _this.format);
                }).join(', ');
            }

            let start = dateTimeString(this.start, this.format);

            if (this.end) {
                let end = dateTimeString(this.end, this.format);
                return start === end ? start : start + ' ' + this.separator + ' ' + end;
            }

            return start;
        },
    },
};
</script>
